// @flow
'use strict';

import * as React from 'react';

import type { IEmitente } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

type EmitenteProps = {
  emitente : IEmitente,
};

export default function Emitente({ emitente } : EmitenteProps) {
  return (
      <div className="tab-pane active">
        <h3>Emitente</h3>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="cnpj" type="documento" width="50%">{ tipoDocumento(emitente) }</ColumnDetalhes>
          <ColumnDetalhes field="ie" width="50%">Inscrição Estadual</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="iest" width="50%">Inscrição Estadual ST</ColumnDetalhes>
          <ColumnDetalhes field="nomeRazaoSocial" width="50%">Nome / Razão Social</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="nomeFantasia" width="50%">Nome Fantasia</ColumnDetalhes>
          <ColumnDetalhes field="endereco" width="50%">Endereço</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="bairro" width="50%">Bairro</ColumnDetalhes>
          <ColumnDetalhes field="municipio" width="50%">Município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente } className="no-margin-bottom">
          <ColumnDetalhes field="cep" type="cep" width="50%">CEP</ColumnDetalhes>
          <ColumnDetalhes field="uf" width="50%">UF</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ emitente }>
          <ColumnDetalhes field="telefone" width="50%">Telefone</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}
